function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" {...props}><path d="M14.823 5.8l-.615.604-3.232-3.122v10.686h-.855V2h.834l3.868 3.8zM5.87 13.968L2 10.168l.616-.604 3.231 3.122V2h.855v11.968h-.833z" /></svg>;
});